import React from 'react';
import DTOTeamReviewModal from './DTOTeamReviewModal';
import { performanceService } from '../../../../api/services/performanceService';
import toast from 'react-hot-toast';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { useTranslation } from 'react-i18next';
import { setAnswerId } from '../../../../infra/aggregates/myProfile/EvaluatorData/evaluatorData';
import TeamReviewQuestionnaireModalPresenter from './TeamReviewQuestionnaireModalPresenter';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const TeamReviewModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const { t, i18n } = useTranslation();
  const questionnaireId = useAppSelector(
    (state) => state.evaluatorDetails?.questionnaireId,
  );
  const dispatch = useAppDispatch();
  //POST Answer
  async function postAnswers(payload: any) {
    try {
      const response: any = await performanceService?.postAnswers(payload);

      dispatch(setAnswerId(response?.data?.[0]?.id));
      toast.success(t('answer-save-successfully'));
    } catch (error: any) {
      toast.error(error.message);
    }
  }

  //POST SubmitEvaluation
  async function postSubmitEvaluation(payload: any) {
    try {
      const response: any = await performanceService.postEvaluation(
        questionnaireId,
        payload,
      );
      toast.success(t('evaluation-submit-successfully'));
    } catch (error: any) {
      toast.error(error?.message);
    }
  }
  return (
    <div>
      <DTOTeamReviewModal />

      <TeamReviewQuestionnaireModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        answerSubmit={postAnswers}
        evaluationSubmit={postSubmitEvaluation}
      />
    </div>
  );
};

export default TeamReviewModalController;
